"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
angular.module('callX').controller('DiagnoseConnectionCtrl', [
    '$scope',
    '$modalInstance',
    '$interval',
    'plivoWebSdk',
    function ($scope, $modalInstance, $interval, plivoWebSdk) {
        $scope.diagnosing = false;
        $scope.diagnosisLog = '';
        $scope.systemInfo = {};
        $scope.activeTab = 'basic';
        $scope.advanced = {
            callUUID: null,
            plivoLoggedIn: 'N/A',
            callDirection: null,
            callState: null,
            codec: null,
            mos: null,
            mosColor: '#1f2937',
            pdd: null,
            mediaSetupTime: null,
            plivoNetworkType: null,
            plivoEffectiveType: null,
            plivoDownlink: null,
            localAudioLevel: null,
            remoteAudioLevel: null,
            echoReturnLoss: null,
            echoReturnLossEnhancement: null,
            concealedSamples: null,
            silentConcealedSamples: null,
            fractionLoss: null,
            jitterBufferDelay: null,
            packetsDiscarded: null,
            localCandidateType: null,
            remoteCandidateType: null,
            protocol: null,
            dtlsState: null,
            iceState: null,
            selectedCandidatePairChanges: null,
            relayProtocol: null,
            packetsSent: null,
            bytesSent: null,
            retransmittedBytesSent: null,
            retransmittedPacketsSent: null,
            inboundPacketsReceived: null,
            inboundBytesReceived: null,
            jitterBufferEmittedCount: null,
            insertedSamplesForDeceleration: null,
            removedSamplesForAcceleration: null,
            totalAudioEnergy: null,
            micPermission: 'Checking...',
            notificationPermission: null,
            tabVisibility: null,
            dataSaver: null,
            language: null,
            jsHeapUsed: null,
            jsHeapLimit: null,
            audioDevices: []
        };
        var diagnosisInterval = null;
        var prevPacketsReceived = 0;
        var prevPacketsLost = 0;
        // ── System Information ──────────────────────────────────────────────
        function getConnection() {
            return navigator.connection || navigator.mozConnection || navigator.webkitConnection || null;
        }
        function getSystemInfo() {
            var ua = navigator.userAgent;
            $scope.systemInfo = {
                os: parseOS(ua),
                browser: parseBrowser(ua),
                ram: getRAM(),
                cpuCores: getCPUCores(),
                screenResolution: getScreenResolution(),
                networkType: getNetworkType(),
                effectiveType: getEffectiveType(),
                downlink: getDownlink(),
                networkRtt: getNetworkRtt()
            };
        }
        function parseOS(ua) {
            if (/Windows NT 10/.test(ua))
                return 'Windows 10/11';
            if (/Windows NT 6\.3/.test(ua))
                return 'Windows 8.1';
            if (/Windows NT 6\.2/.test(ua))
                return 'Windows 8';
            if (/Windows NT 6\.1/.test(ua))
                return 'Windows 7';
            if (/Mac OS X ([\d_]+)/.test(ua)) {
                var ver = (RegExp.$1 || '').replace(/_/g, '.');
                return 'macOS ' + ver;
            }
            if (/CrOS/.test(ua))
                return 'Chrome OS';
            if (/Linux/.test(ua))
                return 'Linux';
            if (/Android ([\d.]+)/.test(ua))
                return 'Android ' + RegExp.$1;
            if (/iPhone OS ([\d_]+)/.test(ua))
                return 'iOS ' + (RegExp.$1 || '').replace(/_/g, '.');
            return 'Unknown';
        }
        function parseBrowser(ua) {
            if (/Edg\/([\d.]+)/.test(ua))
                return 'Microsoft Edge ' + RegExp.$1;
            if (/OPR\/([\d.]+)/.test(ua))
                return 'Opera ' + RegExp.$1;
            if (/Chrome\/([\d.]+)/.test(ua))
                return 'Google Chrome ' + RegExp.$1;
            if (/Firefox\/([\d.]+)/.test(ua))
                return 'Firefox ' + RegExp.$1;
            if (/Safari\/([\d.]+)/.test(ua) && /Version\/([\d.]+)/.test(ua))
                return 'Safari ' + RegExp.$1;
            return 'Unknown';
        }
        function getRAM() {
            var mem = navigator.deviceMemory;
            if (mem != null) {
                return mem >= 8 ? '8+ GB' : mem + ' GB';
            }
            return 'Not available';
        }
        function getCPUCores() {
            var cores = navigator.hardwareConcurrency;
            return cores ? cores + ' logical cores' : 'Not available';
        }
        function getScreenResolution() {
            return window.screen.width + ' x ' + window.screen.height + ' @ ' + (window.devicePixelRatio || 1) + 'x';
        }
        function getNetworkType() {
            var conn = getConnection();
            if (!conn)
                return 'Not available (API not supported)';
            // conn.type is available on mobile browsers (wifi, cellular, ethernet, etc.)
            if (conn.type && conn.type !== 'unknown')
                return conn.type;
            // On desktop, type is unavailable — infer from effectiveType + downlink
            var eff = conn.effectiveType || '';
            var dl = conn.downlink;
            if (eff === '4g' && dl != null && dl >= 5)
                return 'WiFi / Ethernet (inferred)';
            if (eff === '4g')
                return 'WiFi / Ethernet (inferred)';
            if (eff === '3g')
                return 'Slow WiFi / Mobile (inferred)';
            if (eff === '2g' || eff === 'slow-2g')
                return 'Very slow connection (inferred)';
            return 'Unknown';
        }
        function getEffectiveType() {
            var conn = getConnection();
            if (!conn)
                return 'Not available';
            return conn.effectiveType || 'Not available';
        }
        function getDownlink() {
            var conn = getConnection();
            if (!conn)
                return 'Not available';
            if (conn.downlink != null && conn.downlink > 0)
                return conn.downlink + ' Mbps';
            return 'Not available';
        }
        function getNetworkRtt() {
            var conn = getConnection();
            if (!conn)
                return 'Not available';
            if (conn.rtt != null && conn.rtt > 0)
                return conn.rtt + ' ms';
            return 'Not available';
        }
        // ── Diagnosis Stats Collection ──────────────────────────────────────
        function formatTimestamp() {
            var d = new Date();
            var h = ('0' + d.getHours()).slice(-2);
            var m = ('0' + d.getMinutes()).slice(-2);
            var s = ('0' + d.getSeconds()).slice(-2);
            return '[' + h + ':' + m + ':' + s + ']';
        }
        function appendLog(line) {
            $scope.diagnosisLog += line + '\n';
            // Auto-scroll the textarea
            setTimeout(function () {
                var el = document.querySelector('.diagnose-modal-textarea');
                if (el)
                    el.scrollTop = el.scrollHeight;
            }, 0);
        }
        function collectStats() {
            return __awaiter(this, void 0, void 0, function* () {
                var pc = null;
                var ts = formatTimestamp();
                try {
                    if (plivoWebSdk && plivoWebSdk.client) {
                        var pcInfo = plivoWebSdk.client.getPeerConnection();
                        if (pcInfo && pcInfo.pc) {
                            pc = pcInfo.pc;
                        }
                    }
                }
                catch (e) {
                    // getPeerConnection may throw if no active call
                }
                if (!pc) {
                    // Fallback: try Plivo internal stats
                    try {
                        var session = plivoWebSdk && plivoWebSdk.client && plivoWebSdk.client._currentSession;
                        if (session && session.stats && session.stats.collected) {
                            var collected = session.stats.collected;
                            var local = collected.local || {};
                            var remote = collected.remote || {};
                            appendLog(ts + '  Packet Loss: ' + (remote.packetsLost != null ? remote.packetsLost : 'N/A') +
                                '  |  Jitter: ' + (local.jitter != null ? (local.jitter * 1000).toFixed(1) + ' ms' : 'N/A') +
                                '  |  RTT: ' + (local.rtt != null ? (local.rtt * 1000).toFixed(1) + ' ms' : 'N/A') +
                                '  |  Bitrate: N/A (Plivo stats)');
                            $scope.$applyAsync();
                            return;
                        }
                    }
                    catch (e) {
                        // ignore
                    }
                    appendLog(ts + '  No active connection — waiting for a call...');
                    $scope.$applyAsync();
                    return;
                }
                // Collect native WebRTC stats
                try {
                    var stats = yield pc.getStats();
                    var jitter = null;
                    var packetsLost = null;
                    var packetsReceived = null;
                    var rtt = null;
                    var availableBitrate = null;
                    stats.forEach(function (report) {
                        if (report.type === 'inbound-rtp' && report.kind === 'audio') {
                            jitter = report.jitter;
                            packetsLost = report.packetsLost;
                            packetsReceived = report.packetsReceived;
                        }
                        if (report.type === 'candidate-pair' && report.nominated) {
                            rtt = report.currentRoundTripTime;
                            if (report.availableOutgoingBitrate != null) {
                                availableBitrate = report.availableOutgoingBitrate;
                            }
                        }
                    });
                    // Calculate incremental packet loss percentage
                    var lossPercent = 'N/A';
                    if (packetsLost != null && packetsReceived != null) {
                        var deltaLost = packetsLost - prevPacketsLost;
                        var deltaReceived = packetsReceived - prevPacketsReceived;
                        var totalDelta = deltaLost + deltaReceived;
                        if (totalDelta > 0) {
                            lossPercent = ((deltaLost / totalDelta) * 100).toFixed(2) + '%';
                        }
                        else {
                            lossPercent = '0.00%';
                        }
                        prevPacketsLost = packetsLost;
                        prevPacketsReceived = packetsReceived;
                    }
                    var jitterStr = jitter != null ? (jitter * 1000).toFixed(1) + ' ms' : 'N/A';
                    var rttStr = rtt != null ? (rtt * 1000).toFixed(1) + ' ms' : 'N/A';
                    var bitrateStr = availableBitrate != null ? (availableBitrate / 1000).toFixed(1) + ' kbps' : 'N/A';
                    appendLog(ts + '  Packet Loss: ' + lossPercent +
                        '  |  Jitter: ' + jitterStr +
                        '  |  RTT: ' + rttStr +
                        '  |  Bitrate: ' + bitrateStr);
                }
                catch (e) {
                    appendLog(ts + '  Error collecting stats: ' + e.message);
                }
                $scope.$applyAsync();
            });
        }
        // ── Advanced Diagnostics ────────────────────────────────────────────
        function getMosColor(mos) {
            if (mos >= 4)
                return '#22c55e';
            if (mos >= 3)
                return '#f59e0b';
            return '#ef4444';
        }
        function formatBytes(bytes) {
            if (bytes == null)
                return 'N/A';
            if (bytes < 1024)
                return bytes + ' B';
            if (bytes < 1048576)
                return (bytes / 1024).toFixed(1) + ' KB';
            return (bytes / 1048576).toFixed(2) + ' MB';
        }
        function collectAdvancedStats() {
            return __awaiter(this, void 0, void 0, function* () {
                var adv = $scope.advanced;
                // ── Plivo SDK data ──
                try {
                    if (plivoWebSdk && plivoWebSdk.client) {
                        adv.plivoLoggedIn = plivoWebSdk.client.isLoggedIn ? 'Yes' : 'No';
                        try {
                            var uuid = plivoWebSdk.client.getCallUUID();
                            adv.callUUID = uuid || null;
                        }
                        catch (e) { /* no active call */ }
                        var session = plivoWebSdk.client._currentSession;
                        if (session) {
                            // Call info
                            try {
                                var callInfo = session.getCallInfo && session.getCallInfo();
                                if (callInfo) {
                                    adv.callDirection = callInfo.direction || null;
                                    adv.callState = callInfo.state || null;
                                }
                            }
                            catch (e) { /* ignore */ }
                            // Signalling info (PDD, media setup, timing)
                            try {
                                var sigInfo = session.signallingInfo || (session.getSignallingInfo && session.getSignallingInfo()) || {};
                                adv.pdd = sigInfo.post_dial_delay != null ? sigInfo.post_dial_delay + ' ms' : null;
                                if (!adv.pdd && session.postDialDelayEndTime && sigInfo.invite_time) {
                                    adv.pdd = (session.postDialDelayEndTime - sigInfo.invite_time) + ' ms';
                                }
                            }
                            catch (e) { /* ignore */ }
                            // GetRTPStats instance
                            var rtpStats = session.stats;
                            if (rtpStats) {
                                // Audio levels directly on the GetRTPStats instance
                                adv.localAudioLevel = rtpStats.audioInputLevel != null ? String(rtpStats.audioInputLevel) : null;
                                adv.remoteAudioLevel = rtpStats.audioOutputLevel != null ? String(rtpStats.audioOutputLevel) : null;
                                // Collected stats object (populated by Plivo's internal 5s interval)
                                var c = rtpStats.collected;
                                if (c) {
                                    adv.codec = c.codec || null;
                                    adv.plivoNetworkType = c.networkType || null;
                                    adv.plivoEffectiveType = c.networkEffectiveType || null;
                                    adv.plivoDownlink = c.networkDownlinkSpeed != null ? c.networkDownlinkSpeed + ' Mbps' : null;
                                    if (c.pdd != null)
                                        adv.pdd = c.pdd + ' ms';
                                    if (c.mediaSetupTime != null)
                                        adv.mediaSetupTime = c.mediaSetupTime + ' ms';
                                    var local = c.local || {};
                                    var remote = c.remote || {};
                                    if (local.mos != null && local.mos !== 0) {
                                        adv.mos = local.mos.toFixed(2);
                                        adv.mosColor = getMosColor(local.mos);
                                    }
                                    // Fallback audio levels from collected stats
                                    if (!adv.localAudioLevel && local.audioLevel != null) {
                                        adv.localAudioLevel = local.audioLevel.toFixed(4);
                                    }
                                    if (!adv.localAudioLevel && local.audioInputLevel != null) {
                                        adv.localAudioLevel = String(local.audioInputLevel);
                                    }
                                    if (!adv.remoteAudioLevel && remote.audioLevel != null) {
                                        adv.remoteAudioLevel = remote.audioLevel.toFixed(4);
                                    }
                                    if (!adv.remoteAudioLevel && remote.audioOutputLevel != null) {
                                        adv.remoteAudioLevel = String(remote.audioOutputLevel);
                                    }
                                    adv.echoReturnLoss = local.googEchoCancellationReturnLoss != null ? local.googEchoCancellationReturnLoss.toFixed(2) + ' dB' : null;
                                    adv.echoReturnLossEnhancement = local.googEchoCancellationReturnLossEnhancement != null ? local.googEchoCancellationReturnLossEnhancement.toFixed(2) + ' dB' : null;
                                    adv.fractionLoss = remote.fractionLoss != null ? (remote.fractionLoss * 100).toFixed(2) + '%' : null;
                                    adv.jitterBufferDelay = remote.jitterBufferDelay != null ? remote.jitterBufferDelay.toFixed(1) + ' ms' : null;
                                    adv.packetsDiscarded = remote.packetsDiscarded != null ? String(remote.packetsDiscarded) : null;
                                }
                            }
                        }
                    }
                }
                catch (e) { /* ignore */ }
                // ── Native RTCPeerConnection stats ──
                try {
                    var pcInfo = plivoWebSdk && plivoWebSdk.client && plivoWebSdk.client.getPeerConnection();
                    var pc = pcInfo && pcInfo.pc;
                    if (pc) {
                        var stats = yield pc.getStats();
                        var localCandidateId = null;
                        var remoteCandidateId = null;
                        stats.forEach(function (report) {
                            // Outbound RTP
                            if (report.type === 'outbound-rtp' && report.kind === 'audio') {
                                adv.packetsSent = String(report.packetsSent || 0);
                                adv.bytesSent = formatBytes(report.bytesSent);
                                adv.retransmittedBytesSent = formatBytes(report.retransmittedBytesSent);
                                adv.retransmittedPacketsSent = report.retransmittedPacketsSent != null ? String(report.retransmittedPacketsSent) : null;
                            }
                            // Inbound RTP
                            if (report.type === 'inbound-rtp' && report.kind === 'audio') {
                                adv.inboundPacketsReceived = String(report.packetsReceived || 0);
                                adv.inboundBytesReceived = formatBytes(report.bytesReceived);
                                adv.concealedSamples = report.concealedSamples != null ? String(report.concealedSamples) : null;
                                adv.silentConcealedSamples = report.silentConcealedSamples != null ? String(report.silentConcealedSamples) : null;
                                adv.jitterBufferEmittedCount = report.jitterBufferEmittedCount != null ? String(report.jitterBufferEmittedCount) : null;
                                adv.insertedSamplesForDeceleration = report.insertedSamplesForDeceleration != null ? String(report.insertedSamplesForDeceleration) : null;
                                adv.removedSamplesForAcceleration = report.removedSamplesForAcceleration != null ? String(report.removedSamplesForAcceleration) : null;
                                adv.totalAudioEnergy = report.totalAudioEnergy != null ? report.totalAudioEnergy.toFixed(6) : null;
                            }
                            // Candidate pair (nominated)
                            if (report.type === 'candidate-pair' && report.nominated) {
                                localCandidateId = report.localCandidateId;
                                remoteCandidateId = report.remoteCandidateId;
                            }
                            // Transport
                            if (report.type === 'transport') {
                                adv.dtlsState = report.dtlsState || null;
                                adv.iceState = report.iceLocalCandidateId ? 'connected' : (report.dtlsState || null);
                                adv.selectedCandidatePairChanges = report.selectedCandidatePairChanges != null ? String(report.selectedCandidatePairChanges) : null;
                            }
                            // Media source (for echo return loss from WebRTC directly)
                            if (report.type === 'media-source' && report.kind === 'audio') {
                                if (!adv.localAudioLevel && report.audioLevel != null) {
                                    adv.localAudioLevel = report.audioLevel.toFixed(4);
                                }
                                if (!adv.echoReturnLoss && report.echoReturnLoss != null) {
                                    adv.echoReturnLoss = report.echoReturnLoss.toFixed(2) + ' dB';
                                }
                                if (!adv.echoReturnLossEnhancement && report.echoReturnLossEnhancement != null) {
                                    adv.echoReturnLossEnhancement = report.echoReturnLossEnhancement.toFixed(2) + ' dB';
                                }
                            }
                        });
                        // Resolve candidate details
                        if (localCandidateId) {
                            var localCand = stats.get(localCandidateId);
                            if (localCand) {
                                adv.localCandidateType = localCand.candidateType || null;
                                adv.protocol = localCand.protocol || null;
                                adv.relayProtocol = localCand.relayProtocol || 'none (direct)';
                            }
                        }
                        if (remoteCandidateId) {
                            var remoteCand = stats.get(remoteCandidateId);
                            if (remoteCand) {
                                adv.remoteCandidateType = remoteCand.candidateType || null;
                            }
                        }
                    }
                }
                catch (e) { /* no active peer connection */ }
                // ── Browser & Permissions ──
                adv.notificationPermission = typeof Notification !== 'undefined' ? Notification.permission : 'Not supported';
                adv.tabVisibility = document.visibilityState || 'N/A';
                adv.language = navigator.language || 'N/A';
                var conn = getConnection();
                adv.dataSaver = conn && conn.saveData != null ? (conn.saveData ? 'Enabled' : 'Disabled') : 'Not available';
                var perf = performance.memory;
                if (perf) {
                    adv.jsHeapUsed = formatBytes(perf.usedJSHeapSize);
                    adv.jsHeapLimit = formatBytes(perf.jsHeapSizeLimit);
                }
                else {
                    adv.jsHeapUsed = 'Not available';
                    adv.jsHeapLimit = 'Not available';
                }
                // Audio devices — deduplicate by deviceId
                try {
                    if (navigator.mediaDevices && navigator.mediaDevices.enumerateDevices) {
                        var devices = yield navigator.mediaDevices.enumerateDevices();
                        var seen = {};
                        adv.audioDevices = devices.filter(function (d) {
                            if (d.kind !== 'audioinput' && d.kind !== 'audiooutput')
                                return false;
                            var key = d.kind + ':' + d.deviceId;
                            if (seen[key])
                                return false;
                            seen[key] = true;
                            return true;
                        }).map(function (d) {
                            return { kind: d.kind, deviceId: d.deviceId, label: d.label || 'Unnamed (' + d.deviceId.substring(0, 8) + '...)' };
                        });
                    }
                }
                catch (e) {
                    adv.audioDevices = [];
                }
                // Mic permission
                try {
                    if (navigator.permissions && navigator.permissions.query) {
                        var result = yield navigator.permissions.query({ name: 'microphone' });
                        adv.micPermission = result.state;
                    }
                    else {
                        adv.micPermission = 'API not supported';
                    }
                }
                catch (e) {
                    adv.micPermission = 'Unable to query';
                }
                $scope.$applyAsync();
            });
        }
        $scope.switchToAdvanced = function () {
            $scope.activeTab = 'advanced';
            collectAdvancedStats();
        };
        // ── Start / Stop ────────────────────────────────────────────────────
        $scope.startDiagnosis = function () {
            if ($scope.diagnosing)
                return;
            $scope.diagnosing = true;
            prevPacketsReceived = 0;
            prevPacketsLost = 0;
            appendLog(formatTimestamp() + '  Diagnosis started...');
            // Update network info each time we start
            $scope.systemInfo.networkType = getNetworkType();
            $scope.systemInfo.effectiveType = getEffectiveType();
            $scope.systemInfo.downlink = getDownlink();
            $scope.systemInfo.networkRtt = getNetworkRtt();
            collectStats();
            diagnosisInterval = $interval(function () {
                collectStats();
                if ($scope.activeTab === 'advanced') {
                    collectAdvancedStats();
                }
            }, 2000);
        };
        $scope.stopDiagnosis = function () {
            $scope.diagnosing = false;
            if (diagnosisInterval) {
                $interval.cancel(diagnosisInterval);
                diagnosisInterval = null;
            }
            appendLog(formatTimestamp() + '  Diagnosis stopped.');
        };
        $scope.cancel = function () {
            if (diagnosisInterval) {
                $interval.cancel(diagnosisInterval);
                diagnosisInterval = null;
            }
            $modalInstance.dismiss('cancel');
        };
        // Cleanup on destroy
        $scope.$on('$destroy', function () {
            if (diagnosisInterval) {
                $interval.cancel(diagnosisInterval);
                diagnosisInterval = null;
            }
        });
        // ── Copy to Clipboard ────────────────────────────────────────────────
        $scope.copyToClipboard = function () {
            return __awaiter(this, void 0, void 0, function* () {
                // Refresh all data before copying
                getSystemInfo();
                yield collectAdvancedStats();
                var info = $scope.systemInfo;
                var adv = $scope.advanced;
                var lines = [
                    '=== Diagnose Connection Report ===',
                    'Date: ' + new Date().toLocaleString(),
                    '',
                    '--- System Information ---',
                    'OS: ' + info.os,
                    'Browser: ' + info.browser,
                    'RAM: ' + info.ram,
                    'CPU Cores: ' + info.cpuCores,
                    'Screen: ' + info.screenResolution,
                    'Network Type: ' + info.networkType,
                    'Effective Type: ' + info.effectiveType,
                    'Downlink: ' + info.downlink,
                    'Network RTT: ' + info.networkRtt,
                    '',
                    '--- Plivo Call Info ---',
                    'Call UUID: ' + (adv.callUUID || 'No active call'),
                    'Plivo Logged In: ' + adv.plivoLoggedIn,
                    'Call Direction: ' + (adv.callDirection || 'N/A'),
                    'Call State: ' + (adv.callState || 'N/A'),
                    'Codec: ' + (adv.codec || 'N/A'),
                    'MOS Score: ' + (adv.mos || 'N/A'),
                    'Post Dial Delay: ' + (adv.pdd || 'N/A'),
                    'Media Setup Time: ' + (adv.mediaSetupTime || 'N/A'),
                    'Plivo Network Type: ' + (adv.plivoNetworkType || 'N/A'),
                    'Plivo Effective Type: ' + (adv.plivoEffectiveType || 'N/A'),
                    'Plivo Downlink: ' + (adv.plivoDownlink || 'N/A'),
                    '',
                    '--- Audio Levels & Quality ---',
                    'Local Audio Level: ' + (adv.localAudioLevel || 'N/A'),
                    'Remote Audio Level: ' + (adv.remoteAudioLevel || 'N/A'),
                    'Echo Return Loss: ' + (adv.echoReturnLoss || 'N/A'),
                    'Echo Return Loss Enh.: ' + (adv.echoReturnLossEnhancement || 'N/A'),
                    'Concealed Samples: ' + (adv.concealedSamples || 'N/A'),
                    'Silent Concealed Samples: ' + (adv.silentConcealedSamples || 'N/A'),
                    'Fraction Loss: ' + (adv.fractionLoss || 'N/A'),
                    'Jitter Buffer Delay: ' + (adv.jitterBufferDelay || 'N/A'),
                    'Packets Discarded: ' + (adv.packetsDiscarded || 'N/A'),
                    '',
                    '--- ICE & Transport ---',
                    'Local Candidate Type: ' + (adv.localCandidateType || 'N/A'),
                    'Remote Candidate Type: ' + (adv.remoteCandidateType || 'N/A'),
                    'Protocol: ' + (adv.protocol || 'N/A'),
                    'DTLS State: ' + (adv.dtlsState || 'N/A'),
                    'ICE State: ' + (adv.iceState || 'N/A'),
                    'Candidate Pair Changes: ' + (adv.selectedCandidatePairChanges || 'N/A'),
                    'Relay Protocol: ' + (adv.relayProtocol || 'N/A'),
                    '',
                    '--- Outbound RTP ---',
                    'Packets Sent: ' + (adv.packetsSent || 'N/A'),
                    'Bytes Sent: ' + (adv.bytesSent || 'N/A'),
                    'Retransmitted Bytes: ' + (adv.retransmittedBytesSent || 'N/A'),
                    'Retransmitted Packets: ' + (adv.retransmittedPacketsSent || 'N/A'),
                    '',
                    '--- Inbound RTP ---',
                    'Packets Received: ' + (adv.inboundPacketsReceived || 'N/A'),
                    'Bytes Received: ' + (adv.inboundBytesReceived || 'N/A'),
                    'Jitter Buffer Emitted: ' + (adv.jitterBufferEmittedCount || 'N/A'),
                    'Inserted Samples (Decel): ' + (adv.insertedSamplesForDeceleration || 'N/A'),
                    'Removed Samples (Accel): ' + (adv.removedSamplesForAcceleration || 'N/A'),
                    'Total Audio Energy: ' + (adv.totalAudioEnergy || 'N/A'),
                    '',
                    '--- Browser & Permissions ---',
                    'Microphone Permission: ' + (adv.micPermission || 'N/A'),
                    'Notification Permission: ' + (adv.notificationPermission || 'N/A'),
                    'Tab Visibility: ' + (adv.tabVisibility || 'N/A'),
                    'Data Saver: ' + (adv.dataSaver || 'N/A'),
                    'Language: ' + (adv.language || 'N/A'),
                    'JS Heap Used: ' + (adv.jsHeapUsed || 'N/A'),
                    'JS Heap Limit: ' + (adv.jsHeapLimit || 'N/A'),
                    '',
                    '--- Audio Devices (' + (adv.audioDevices.length || 0) + ') ---'
                ];
                adv.audioDevices.forEach(function (d) {
                    lines.push((d.kind === 'audioinput' ? 'Mic: ' : 'Speaker: ') + d.label);
                });
                lines.push('');
                lines.push('--- Connection Stats Log ---');
                lines.push($scope.diagnosisLog || '(no stats collected yet)');
                var text = lines.join('\n');
                navigator.clipboard.writeText(text).then(function () {
                    $scope.copySuccess = true;
                    $scope.$applyAsync();
                    setTimeout(function () {
                        $scope.copySuccess = false;
                        $scope.$applyAsync();
                    }, 2000);
                });
            });
        };
        // ── Init ────────────────────────────────────────────────────────────
        getSystemInfo();
    }
]);
